import { useCallback } from 'react';
import * as Store from '@apply/store';
import { Question, QuestionType, PageQuestionProps, TextWithSelectValue } from '@apply/ui';
import { connect } from 'react-redux';

export interface LandSizePageQuestionProps extends PageQuestionProps {
    onChangeLandSize: (guid: string, value: Store.PropertiesStore.Types.LandSize) => void;
}

const LandSize: React.FC<LandSizePageQuestionProps> = ({ onQuestionValidate, submitted, property, onChangeLandSize }) => {
    const handleLandSize = useCallback(
        (newvalue: TextWithSelectValue) => {
            onChangeLandSize(property.guid, {
                quantity: newvalue.text,
                unit: newvalue.select as Store.PropertiesStore.Types.LandSizeUnit,
            });
        },
        [onChangeLandSize, property?.guid]
    );

    return (
        <div className='form-group'>
            <div className='row'>
                <Question
                    type={QuestionType.NumberWithSelect}
                    submitted={submitted}
                    selector='landSize'
                    styleName='ungrouped'
                    onQuestionValidate={onQuestionValidate}
                    values={[
                        { display: '', value: '' },
                        { display: 'Square Feet', value: 'Square Feet' },
                        { display: 'Acres', value: 'Acres' },
                    ]}
                    value={{
                        text: property.nonRental?.landSize.quantity || '',
                        select: property.nonRental?.landSize.unit || '',
                    }}
                    onChange={handleLandSize}
                >
                    Land Size
                </Question>
            </div>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: {
        onChangeLandSize: (guid: string, value: Store.PropertiesStore.Types.LandSize) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChangeLandSize: (guid: string, value: Store.PropertiesStore.Types.LandSize) =>
            dispatch(Store.PropertiesStore.Actions.updateLandSize(guid, value)),
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(LandSize);
